module.exports = __webpack_public_path__ + "static/media/p2.d57c0da8.png";